/**
 * Footer interactions: the newsletter form is demo-only (no backend), so
 * submitting just reveals a thank-you state instead of posting anywhere.
 */
export function initFooter() {
	const footer = document.querySelector( '.site-footer' );
	if ( ! footer ) return;

	const form = footer.querySelector( '[data-newsletter-form]' );
	if ( form ) {
		form.addEventListener( 'submit', ( e ) => {
			e.preventDefault();
			footer.classList.add( 'newsletter-submitted' );
		} );
	}

	const toTopBtn = footer.querySelector( '[data-scroll-top]' );
	if ( toTopBtn ) {
		toTopBtn.addEventListener( 'click', () => {
			const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
			window.scrollTo( { top: 0, behavior: reduceMotion ? 'auto' : 'smooth' } );
		} );
	}
}
